import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const PROMPT = encodeURIComponent(
  '¿Qué sabes de Notaría Pública 90 de Playa del Carmen, Quintana Roo (notariapublica90.com)? Resume sus servicios notariales, su reputación y su enfoque Legaltech 4.0.'
);

const AIS = [
  { id: 'claude', name: 'Claude', url: `https://claude.ai/new?q=${PROMPT}` },
  { id: 'chatgpt', name: 'Chat GPT', url: `https://chatgpt.com/?q=${PROMPT}` },
  { id: 'gemini', name: 'Gemini', url: `https://www.google.com/search?udm=50&q=${PROMPT}` },
  { id: 'perplexity', name: 'Perplexity', url: `https://www.perplexity.ai/search?q=${PROMPT}` },
];

const AskAI = () => (
  <section className="py-20 bg-slate-50" data-testid="ask-ai-section">
    <div className="container mx-auto px-4 text-center">
      <h2 className="text-2xl md:text-3xl font-bold text-notaria-primary mb-10" data-testid="ask-ai-title">
        Descubre lo que tu IA favorita dice de Notaría Pública 90:
      </h2>
      <div className="flex flex-wrap justify-center gap-4">
        {AIS.map((ai) => (
          <a
            key={ai.id}
            href={ai.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`ask-ai-${ai.id}-btn`}
            className="group inline-flex items-center gap-2 px-6 py-3 rounded-xl border-2 border-notaria-secondary text-notaria-primary font-medium bg-white hover:bg-notaria-primary hover:border-notaria-primary hover:text-white transition-colors duration-200"
          >
            Pregunta a {ai.name}
            <ArrowUpRight className="w-4 h-4 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default AskAI;
